import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkLoggedIn } from '../store/actions/checkPermissions';
import { PERMISSION_STATUS } from '../constants/permissions';
import Spinner from '../components/common/Spinner';
import NoMatchContainer from '../containers/pages/NoMatchContainer';
import { ServerErrorContainer } from '../containers/pages/ServerErrorContainer';

function UserRequiredHOCWrapper(ComposedComponent) {
  function UserRequiredHOC(props) {
    const dispatch = useDispatch();
    const { isLoading = true, status = null } = useSelector((state) => state.checkPermissions);

    useEffect(() => {
      dispatch(checkLoggedIn());
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (status === PERMISSION_STATUS.DENIED) {
      return <NoMatchContainer />;
    }

    if (status === PERMISSION_STATUS.SERVER_ERROR) {
      return <ServerErrorContainer />;
    }

    if (isLoading) {
      return <Spinner />;
    }

    return <ComposedComponent {...props} />;
  }

  return UserRequiredHOC;
}

export default UserRequiredHOCWrapper;
